import { render, staticRenderFns } from "./ModalDiscountExtraValueItem.vue?vue&type=template&id=1027d5a0&"
import script from "./ModalDiscountExtraValueItem.vue?vue&type=script&lang=js&"
export * from "./ModalDiscountExtraValueItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalDiscountExtraValueItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports